// project import
import Navigation from './navigation';

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = () => (
    <Navigation />
);

export default DrawerContent;
